import React, { useContext } from "react";
import { Grid, Paper } from "@mui/material";

import PrimarySearchAppBar from "../../Components/Layout/Header";
import Map from "../../Components/Home/MapDriver";
import CardSection from "../../Components/Home/CardSection";
import Footer from "../../Components/Home/Footer";
import DataTable from "../../Components/Home/FilterTable";
import TopSection from "../../Components/Home/TopSection";
import Doughnut from "../../Components/Home/Doughnut";
import UnstyledTable from "../../Components/Home/Emergency";
import AppContext from "../../../context/app-context";

function Index() {
  const { emergency, numberOfEmergency } = useContext(AppContext);
  return (
    <div
      style={{
        minHeight: "100vh",
        background: emergency
          ? "linear-gradient(180deg, #fff8f8 0%, #f6f8fb 18%, #ffffff 100%)"
          : "linear-gradient(180deg, #f5f8ff 0%, #ffffff 24%, #ffffff 100%)",
      }}
    >
      <PrimarySearchAppBar />
      <div
        style={{
          maxWidth: 1720,
          margin: "0 auto",
          padding: "1rem 1rem 2rem",
        }}
      >
        <div
          style={{
            margin: "1rem 0 1.25rem",
            padding: "1rem 1.25rem",
            borderRadius: 20,
            background: emergency
              ? "linear-gradient(135deg, rgba(229,57,53,0.15), rgba(255,255,255,0.92))"
              : "linear-gradient(135deg, rgba(25,118,210,0.08), rgba(255,255,255,0.95))",
            border: `1px solid ${emergency ? "rgba(229,57,53,0.18)" : "rgba(25,118,210,0.14)"}`,
            boxShadow: "0 12px 32px rgba(15, 23, 42, 0.08)",
          }}
        >
          <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
            <div>
              <div style={{ fontSize: 13, letterSpacing: 1.2, textTransform: "uppercase", color: "#64748b" }}>
                Emergency Control Room
              </div>
              <h3 style={{ margin: "0.25rem 0 0", fontWeight: 800 }}>
                {emergency ? "Button pressed, device marked red" : "Live operational overview"}
              </h3>
            </div>
            <div
              style={{
                padding: "0.6rem 0.9rem",
                borderRadius: 999,
                background: emergency ? "#fee2e2" : "#dcfce7",
                color: emergency ? "#b91c1c" : "#166534",
                fontWeight: 700,
              }}
            >
              {emergency ? `${numberOfEmergency} in emergency` : "All systems green"}
            </div>
          </div>
        </div>

        <Grid sx={{ marginTop: "0.3rem" }} container spacing={2}>
          <Grid container item direction="row" xs={12} spacing={2}>
            <Grid item xs={12} md={3}>
              <Paper
                elevation={0}
                sx={{
                  minHeight: 320,
                  borderRadius: 5,
                  overflow: "hidden",
                  border: "1px solid rgba(15, 23, 42, 0.08)",
                  boxShadow: "0 14px 40px rgba(15, 23, 42, 0.08)",
                }}
              >
                <Doughnut />
              </Paper>
            </Grid>

            <Grid item xs={12} md={9}>
              <Paper
                elevation={0}
                sx={{
                  minHeight: 320,
                  borderRadius: 5,
                  p: 2.5,
                  border: "1px solid rgba(15, 23, 42, 0.08)",
                  boxShadow: "0 14px 40px rgba(15, 23, 42, 0.06)",
                }}
              >
                <TopSection />
              </Paper>
            </Grid>
          </Grid>

          <Grid container item direction="row" xs={12} spacing={2}>
            <Grid item xs={12} md={6}>
              <Paper
                elevation={0}
                sx={{
                  borderRadius: 5,
                  overflow: "hidden",
                  border: "1px solid rgba(15, 23, 42, 0.08)",
                  boxShadow: emergency
                    ? "0 18px 46px rgba(229, 57, 53, 0.14)"
                    : "0 14px 40px rgba(15, 23, 42, 0.08)",
                }}
              >
                <Map />
              </Paper>
            </Grid>

            <Grid item xs={12} md={6}>
              <Paper
                elevation={0}
                sx={{
                  minHeight: 560,
                  borderRadius: 5,
                  p: 2.5,
                  border: "1px solid rgba(15, 23, 42, 0.08)",
                  boxShadow: "0 14px 40px rgba(15, 23, 42, 0.06)",
                }}
              >
                <CardSection />
              </Paper>
            </Grid>
          </Grid>

          <Grid container item direction="row" xs={12} spacing={2}>
            <Grid sx={{ padding: "2%" }} item xs={12} md={8}>
              <div className="text-center mb-3 three">
                <h1 className="d-inline-block">Emergency Sites :-</h1>
              </div>

              <div className="shadow-md fix-width">
                <UnstyledTable />
              </div>
            </Grid>
            <Grid
              sx={{
                padding: "2%",
                textAlign: "center",
              }}
              item
              xs={12}
              md={4}
            />
          </Grid>

          <Grid container item direction="row" xs={12}>
            <Grid sx={{ marginTop: "3rem" }} item xs={12}>
              <DataTable />
            </Grid>
          </Grid>
        </Grid>
      </div>
      <Footer />
    </div>
  );
}
export default Index;
